import React from 'react';
import { render } from 'react-dom';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import AppBar from '@mui/material/AppBar';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

/* Software Written by Alan J Beveridge
ll Rights Reserved

Copyright (c) 2022-2023 ICANCHECK LTD

Created by Alan J Beveridge , ICANCHECK LTD

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.*/



render(
  <React.StrictMode>
    <AppBar position="fixed">
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
        >

        </IconButton>
        <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
        ICanCheck 
        </Typography>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
      Primary Care Cancer Investigation & Referral Assistant
        </Typography>
      </Toolbar>
    </AppBar>
    <Paper sx={{ mt: 8 }}>
      < App />
    </Paper>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
